import { Pipe, PipeTransform } from '@angular/core';

export class Time {
  hours?: string;
  minutes?: string;
  seconds?: string;
}

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {

  transform(value: string, format: string): unknown {
    if(!value){
      return null;
    }
    

    return this.switchformat(this.calcTime(value), format);
  }

  calcTime(value: string) : Time{
    var split = value.split(":");
    var hours = split[0].padStart(2,"0");
    var minutes = split[1].padStart(2,"0");
    var seconds = split[2].padStart(2,"0");

    return {hours: hours, minutes: minutes,seconds:seconds}
  }

  switchformat(value: Time, format: string) : string{
    var result = "";
    switch (format) {
      case 'shortTime':
        result = `${value.hours}:${value.minutes}`
        break;
      case 'mediumTime':
        result = `${value.hours}h ${value.minutes}m`

        break;
      case 'fullTime':
        result = `${value.hours}h ${value.minutes}m ${value.seconds}s`

        break;
      default:
        result = `${value.hours}:${value.minutes}`

        break;
    }
    return result;
  }

}
